export const links = {
    yes: 'https://educacity.com.br/convite/superdigital/',
    no: 'https://educacity.com.br/comprar-carro-sem-entrada-agora/?utm_source=google',
    noFacebook: 'https://educacity.com.br/comprar-carro-sem-entrada-agora/?utm_source=facebook',
    noFacebookB: 'https://educacity.com.br/lp-financiar-carro-sem-entrada-rapido/?utm_source=facebook',
    noFacebookC: 'https://educacity.com.br/lp-carro-proprio-sem-entrada-agora/?utm_source=facebook',
    noFacebookD: 'https://educacity.com.br/lp-descubra-CONseguir-financiamento-sem-entrada/?utm_source=facebook',
    zennexuBlogFacebook: 'https://zennexu.com/lp-comprar-carro-sem-entrada-como-financiar/?utm_source=facebook',
    terms: 'https://educacity.com.br/termos-de-uso/',
    disclaimer: 'https://educacity.com.br/disclaimer/',
    privacy: 'https://educacity.com.br/politica-de-privacidade/'
}

export const bavyroxLinks = {
    redirect: 'https://bavyrox.com/lp-cartao-amazon-anuidade-gratis-e-programa-de-recompensas/?utm_source=google',
    terms: 'https://bavyrox.com/termos-de-uso/',
    disclaimer: 'https://bavyrox.com/disclaimer/',
    privacy: 'https://bavyrox.com/politica-de-privacidade/'
}

export const motoLinks = {
    yes: 'https://educacity.com.br/convite/superdigital/',
    no: 'https://educacity.com.br/lp-saiba-agora-como-realizar-o-sonho-da-moto-propria/?utm_source=google',
    noFacebook: 'https://educacity.com.br/lp-saiba-agora-como-realizar-o-sonho-da-moto-propria/?utm_source=facebook',
}


